import { render, staticRenderFns } from "./message-status-icon.vue?vue&type=template&id=368d1075&scoped=true"
import script from "./message-status-icon.vue?vue&type=script&lang=js"
export * from "./message-status-icon.vue?vue&type=script&lang=js"
import style0 from "./message-status-icon.vue?vue&type=style&index=0&id=368d1075&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d1075",
  null
  
)

export default component.exports